import React from "react";
import { string, func } from "prop-types";

import "./button.m.css";

const Button = ({ content, onClick, buttonType, ...props }) => (
  <button styleName={buttonType} className="button" onClick={onClick} {...props}>
    {content}
  </button>
);

Button.defaultProps = {
  buttonType: "type1",
};

Button.propTypes = {
  content: string.isRequired,
  onClick: func,
  buttonType: string
};

export default Button;
